import axios from '@/axios'
import i18n from '@/lang'
import { Notify, Loading, QSpinnerTail } from 'quasar'
export default {
  state: {
    regions: [{ label: 'Selecione uma região', value: 'X' }],
    pages: 0,
    searchParams: {},
    companyList: [],
    transportType: [],
    states: [
      { label: 'AC', value: 'AC' }, { label: 'AL', value: 'AL' }, { label: 'AP', value: 'AP' },
      { label: 'AM', value: 'AM' }, { label: 'BA', value: 'BA' }, { label: 'CE', value: 'CE' },
      { label: 'DF', value: 'DF' }, { label: 'ES', value: 'ES' }, { label: 'GO', value: 'GO' },
      { label: 'MA', value: 'MA' }, { label: 'MT', value: 'MT' }, { label: 'MS', value: 'MS' },
      { label: 'MG', value: 'MG' }, { label: 'PA', value: 'PA' }, { label: 'PB', value: 'PB' },
      { label: 'PR', value: 'PR' }, { label: 'PE', value: 'PE' }, { label: 'PI', value: 'PI' },
      { label: 'RJ', value: 'RJ' }, { label: 'RN', value: 'RN' }, { label: 'RS', value: 'RS' },
      { label: 'RO', value: 'RO' }, { label: 'RR', value: 'RR' }, { label: 'SC', value: 'SC' },
      { label: 'SP', value: 'SP' }, { label: 'SE', value: 'SE' }, { label: 'TO', value: 'TO' }
    ]
  },
  actions: {
    getRegions ({ commit }, stateSelected) {
      axios.get(`/platform/location/regions?state=${stateSelected}`)
        .then(res => {
          commit('setRegions', res.data)
        })
        .catch(err => {
          console.log(err)
          Notify.create({
            message: 'Houve um erro ao carregar as regiões, caso isso atrapalhe o fluxo da aplicação, contate nosso suporte',
            position: 'top'
          })
        })
    },
    getTransportType ({ commit }) {
      axios.get('/platform/types/transport-types')
        .then(res => {
          commit('setTransportType', res.data)
        })
        .catch(err => {
          console.log(err)
          Notify.create({
            message: 'Não foi possível carregar os tipos de transporte, por favor recarregue a página ou entre em contato conosco',
            position: 'top'
          })
        })
    },
    getCompanyList ({ commit }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post(`/platform/company/search?asc=false&limit=12&order=name&page=${json.index}`, {
        regions: Array.isArray(json.region) ? json.region : new Array(json.region),
        transportType: json.transportName
      })
        .then(res => {
          Loading.hide()
          commit('setCompanyResult', res.data)
        })
        .catch((err) => {
          console.log(err.response)
          Loading.hide()
        })
    },
    disableCompany ({ state, commit }, id) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post(`/platform/company/disable/${id}`)
        .then(res => {
          Notify.create({
            message: 'Empresa desativada com sucesso!',
            position: 'top',
            type: 'positive'
          })
          let filterList = state.companyList.filter(function (el) {
            return el.id !== id
          })
          commit('setCompanyList', filterList)
          Loading.hide()
        })
        .catch(err => {
          console.log(err)
          Notify.create({
            message: 'Erro ao desativar a empresa.',
            position: 'top',
            type: 'negative'
          })
          Loading.hide()
        })
    },
    getListOfCompany ({ commit }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.get(`/platform/company/search-by-name-and-region?name=${json.name}&region=${json.regionSelected}`)
        .then(res => {
          console.log(res)
          commit('setCompanyList', res.data)
          Loading.hide()
        })
        .catch(err => {
          console.log(err)
          Loading.hide()
        })
    }
  },
  mutations: {
    setRegions (state, data) {
      state.regions = []
      data.forEach(element => {
        state.regions.push({ label: 'Região de ' + element, value: element })
      })
    },
    setTransportType (state, data) {
      state.transportType = []
      state.transportType.push({ label: 'TODOS', value: [] })
      data.forEach(element => {
        state.transportType.push({ label: element.replace(/_/g, ' '), value: element })
      })
    },
    setCompanyResult (state, data) {
      state.companyList = []
      state.pages = data.totalPages
      state.companyList = data.content
    },
    setCompanyList (state, data) {
      state.companyList = []
      state.companyList = data
    }
  },
  getters: {
    getStateList: (state) => {
      return state.states
    },
    getTransportTypeList: (state) => {
      return state.transportType
    },
    getRegions: (state) => {
      return state.regions
    },
    getCompanyResults: (state) => {
      return state.companyList
    },
    getPages: (state) => {
      return state.pages
    }
  }
}
